import {
	Select,
	SelectItem,
	SvgIconName
} from "client/Components";
import {
	ReactElement,
	useEffect,
	useMemo
} from "react";
import { CultureId } from "client/Api/Localization/userCulture";
import { useApplicationCultureStore } from "./applicationCultureStore";
import { shallowComparison } from "client/Misc/compareUtils";

export type ApplicationCultureSelectProps = {
	value: string;
	onChange(value: string): void;
	menuTitle: string;
	trackingId?: string;
};

export const ApplicationCultureSelect = (props: ApplicationCultureSelectProps): ReactElement => {
	const {
		value,
		onChange,
		menuTitle,
		trackingId
	} = props;

	const {
		fetch: fetchApplicationCultures,
		state: applicationCultures,
		status
	 } = useApplicationCultureStore(
		(x) => ({
			fetch: x.fetch,
			state: x.state,
			status: x.status
		}),
		shallowComparison
	);

	const options = useMemo(
		(): CultureSelectOptions[] => {
			return applicationCultures.map(
				(x): CultureSelectOptions => ({
					value: x.id,
					text: x.name,
					icon: {
						kind: "svg",
						name: mapCultureIdToIconName[x.id]
					}
				})
			);
		},
		[applicationCultures]
	);

	useEffect(
		(): void => {
			fetchApplicationCultures();
		},
		[fetchApplicationCultures]
	);

	return (
		<Select
			value={value}
			onChange={onChange}
			options={options}
			trackingId={trackingId}
			menuTitle={menuTitle}
			hasBusyIndicator={status === "loading"}
		/>
	);
};
ApplicationCultureSelect.displayName = "ApplicationCultureSelect";

type CultureSelectOptions = SelectItem<string>;

const mapCultureIdToIconName: Record<CultureId, SvgIconName> = {
	"en-AU": "flag-australia",
	"da": "flag-denmark",
	"fr": "flag-france",
	"de": "flag-germany",
	"en-GB": "flag-great-britain",
	"it": "flag-italy",
	"nl": "flag-netherlands",
	"en-NZ": "flag-new-zealand",
	"nb": "flag-norway",
	"es": "flag-spain",
	"sv": "flag-sweden",
	"en": "flag-united-states"
};
